import React from 'react'
import { ControlT } from 'types/internal'
import { MicHealth } from 'shared/utils/useMicHealth'

export interface IStreamContext {
  stream: MediaStream | null
  devices: MediaDeviceInfo[]
  selectedDeviceId: string | null
  changeDeviceId: (deviceId: string) => Promise<void>
  microphones: MediaDeviceInfo[]
  selectedMicId: string | null
  changeMicId: (deviceId: string) => Promise<void>
  controls: ControlT
  changeControls: (controls: ControlT) => Promise<void>
  micHealth: MicHealth
  startStream: () => void
  pauseRecordingLiveness: () => void
  resumeRecordingLiveness: () => void
  releaseStream: () => void
  recordExternalStream: (stream: MediaStream) => void
  recaptureStream: () => Promise<void>
}

const Ctx = React.createContext<IStreamContext>({
  stream: null,
  devices: [],
  selectedDeviceId: null,
  changeDeviceId: async () => undefined,
  microphones: [],
  selectedMicId: null,
  changeMicId: async () => undefined,
  controls: { mic: true, camera: true },
  changeControls: async () => undefined,
  micHealth: { status: 'ok', escalated: false },
  startStream: () => undefined,
  pauseRecordingLiveness: () => undefined,
  resumeRecordingLiveness: () => undefined,
  releaseStream: () => undefined,
  recordExternalStream: () => undefined,
  recaptureStream: async () => undefined
})

export default Ctx
